import dayjs from "dayjs";
const initialParams = {
  offset: 0,
  limit: 10
};
function getShortTime(date) {
  const now = dayjs();
  const value = dayjs(date);
  const diffSeconds = now.diff(value, "second");
  if (diffSeconds < 60)
    return `${diffSeconds}s`;
  const diffMinutes = now.diff(value, "minute");
  if (diffMinutes < 60)
    return `${diffMinutes}m`;
  const diffHours = now.diff(value, "hour");
  if (diffHours < 24)
    return `${diffHours}h`;
  const diffDays = now.diff(value, "day");
  return `${diffDays}d`;
}
export {
  getShortTime,
  initialParams
};
